<template>
  <div>
    <section>
      <Breadcrumbs :breadcrumbs="breadcrumbs">
        <div slot="breadcrumbAfter" class="d-flex align-items-center">
          <div>
            <va-dropdown class="custom-dropdown" v-if="selectedRecord" fixed>
              <span slot="anchor">
              <slot>
                <div class="pl-3 pr-2 clickable">
                  <span class="fa fa-ellipsis-v" style="font-size: 1.5rem;"></span>
                </div>
              </slot>
            </span>
              <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">
                <div class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                    :class="{'dropdown-item-wrapper--disabled': !hasPermissionToEdit}" @click.prevent="editRecord">
                  <div>
                    <i class="fa fa-pencil"></i>
                    {{ $t('ranu.records.actions.edit') }}
                  </div>
                </div>
                <div class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                    :class="{'dropdown-item-wrapper--disabled': !hasPermissionToEdit}" @click.prevent="deleteRecord">
                  <div>
                    <i class="fa fa-trash"></i>
                    {{ $t('ranu.records.actions.delete') }}
                  </div>
                </div>
              </div>
            </va-dropdown>
          </div>

        </div>
      </Breadcrumbs>

      <div v-if="selectedRecord" class="mt-2">

        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <div class="d-flex justify-content-between">
              <h4 class="mb-0">{{ $t('ranu.records.data') }}</h4>
            </div>

            <div class="row mt-3">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.process_id') }}:</span>
              <span class="col-12 col-md-8" v-if="selectedRecord.process_id">{{ selectedRecord.process_id }}</span>
              <span class="col-12 col-md-8" v-else>---</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.sns_number') }}:</span>
              <span class="col-12 col-md-8" v-if="selectedRecord.sns_number">{{ selectedRecord.sns_number }}</span>
              <span class="col-12 col-md-8" v-else>---</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.full_name') }}:</span>
              <span class="col-12 col-md-8" v-if="selectedRecord.name">{{ selectedRecord.name }}</span>
              <span class="col-12 col-md-8" v-else>---</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.risk_factor') }}:</span>
              <span class="col-12 col-md-8" v-if="selectedRecord.risk_factor">
                      <va-popover v-if="selectedRecord.risk_factor.description"
                                  :message="selectedRecord.risk_factor.description"
                                  placement="top">
                        <span>{{ selectedRecord.risk_factor.name }}</span>
                      </va-popover>
                      <span v-else>{{ selectedRecord.risk_factor.name }}</span>
                    </span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.birthdate') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.birthdate | localTime('YYYY-MM-DD HH:mm') }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.entity') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.entity ? selectedRecord.entity.name : null }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.status') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.status ? selectedRecord.status.name : null }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.external') }}:</span>
              <span
                class="col-12 col-md-8">{{
                  selectedRecord.external ? $t('ranu.records.yes') : $t('ranu.records.no')
                }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.obs') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.obs ? selectedRecord.obs : null }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.created_at') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.created_at | localTime('YYYY-MM-DD HH:mm') }}</span>
            </div>
            <div class="row">
              <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.updated_at') }}:</span>
              <span class="col-12 col-md-8">{{ selectedRecord.updated_at | localTime('YYYY-MM-DD HH:mm') }}</span>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">{{ $t('ranu.records.contacts_header') }}</h4>
              <span>
                      <i v-if="selectedRecord.active_license" class="fa fa-external-link custom-icon px-2"
                        @click="redirectToLicense"></i>
                    </span>
            </div>

            <div v-if="selectedRecord.contacts.length" class="mt-3">
              <!-- Contacts Mother Details -->
              <div v-if="contactsByType.mother">
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.mother') }}:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.mother.name || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">Email:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.mother.email || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">Telefone:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.mother.phone || null }}</span>
                </div>
              </div>

              <!-- Contacts Father Details -->
              <div v-if="contactsByType.father">
                <hr class="mt-1 mb-1">
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.father') }}:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.father.name || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">Email:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.father.email || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.phone') }}:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.father.phone || null }}</span>
                </div>
              </div>

              <!-- Contacts Other Details -->
              <div v-if="contactsByType.other">
                <hr class="mt-1 mb-1">
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.father') }}:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.other.name || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">Email:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.other.email || null }}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{ $t('ranu.records.phone') }}:</span>
                  <span class="col-12 col-md-8">{{ contactsByType.other.phone || null }}</span>
                </div>
              </div>
            </div>

            <div v-else class="mt-2">
              <span class="simpleLabel">{{ $t('ranu.records.no_contacts') }}</span>
            </div>
          </div>

        </div>
        <Exams
          :key="key"
          :record="selectedRecord"
          @exam-created="examCreated"
          @exam-updated="examUpdated"
          @exam-deleted="examDeleted" />
      </div>

      <div v-if="!selectedRecord" class="loading-widget text-center d-flex flex-column justify-content-center">

        <h6><b>{{ $t('tables.loading') }}</b></h6>
        <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
    </section>

    <CreateOrUpdate
      v-if="isUpdatingRecord"
      :record="selectedRecord"
      @updated="recordUpdated"
      @modal-closed="recordUpdatedCanceled" />

    <!-- Delete Confirmation Modal -->
    <ConfirmationModal
      v-if="isDestroyingRecord"
      :title="$t('ranu.records.delete_record')"
      :body="$t('ranu.records.delete_modal_body', {process: selectedRecord.process_id})"
      okClass="btn-danger"
      @modal-confirmed="destroyRecord"
      @modal-canceled="cancelDestroyRecord"/>
    <!-- End Delete Confirmation Modal -->

  </div>
</template>
<script>
import { RecordsService } from '@/api/RanuService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import ConfirmationModal from '@/components/common/ConfirmationModal'
import Exams from '@/components/ranu/exams/index'
import CreateOrUpdate from '@/components/ranu/records/CreateOrUpdate'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true,
    },
  },
  components: {
    CreateOrUpdate,
    Breadcrumbs,
    LoadingAnimation,
    ConfirmationModal,
    Exams
  },
  data () {
    return {
      key: 1,
      isUpdatingRecord: false,
      selectedRecord: undefined,
      from: undefined,
      isDestroyingRecord: false
    }
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = [
        { title: this.$t('menu.ranu'), disabled: true },
        { title: this.$t('ranu.records.title'), meta: { type: 'string', value: `/${this.serviceSlug}/ranu/records` } },
      ]

      if (this.selectedRecord) {
        let title = ''

        if (this.selectedRecord.process_id) {
          title = this.$t('ranu.records.process_id') + ' ' + `${this.selectedRecord.process_id}`
        } else {
          title = `Processo com nascimento em ${this.$options.filters.localTime(this.selectedRecord.birthdate, 'YYYY-MM-DD')}`
        }

        breadcrumbs.push({ title, disabled: true })
      }

      return breadcrumbs
    },
    hasPermissionToEdit: function () {
      return true
    },
    contactsByType: function () {
      let types = ['mother', 'father']
      let contacts = {}

      types.forEach(type => {
        contacts[type] = this.getSelectedRecordContactByType(type)
      })

      return contacts
    }
  },
  methods: {
    examUpdated: function (payload) {
      this.selectRecord(this.selectedRecord.id)
    },
    examCreated: function (payload) {
      this.selectRecord(this.selectedRecord.id)
    },
    examDeleted: function ({ exam }) {
      this.selectRecord(this.selectedRecord.id)
    },
    recordUpdated: function ({ record }) {
      this.recordUpdatedCanceled()
      this.selectedRecord = record
      // this.selectRecord(this.selectedRecord.id)
    },
    recordUpdatedCanceled: function () {
      this.isUpdatingRecord = false
    },
    editRecord: function () {
      if (!this.hasPermissionToEdit) return
      this.isUpdatingRecord = true
    },
    getSelectedRecordContactByType: function (contactType) {
      return this.selectedRecord.contacts.find(contact => contact.type === contactType)
    },
    selectRecord: function (recordId, externalRecordPermission) {
      RecordsService.get(recordId, {externalRecordPermission: externalRecordPermission})
        .then(record => {
          this.selectedRecord = record
        })
        .catch(errors => {
          this.redirectBack()
        })
    },
    redirectBack: function () {
      this.$router.go(-1)
    },
    onRecordModalClosed: function () {
      this.isUpdatingRecord = false
    },
    deleteRecord: function (record) {
      if (!this.hasPermissionToEdit) return
      this.isDestroyingRecord = true
    },
    destroyRecord: function () {
      RecordsService.destroy(this.selectedRecord.id)
        .then(response => {
          this.cancelDestroyRecord()
          this.redirectBack()
          this.showToast(this.$t('ranu.records.record_deleted'), this.$store.state.successToastOptions)
        })
        .catch(errors => {
          this.showToast(this.$t('ranu.something_went_wrong'), this.$store.state.errorToastOptions)
        })
    },
    cancelDestroyRecord: function () {
      this.isDestroyingRecord = false
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.selectRecord(parseInt(to.params.id), to.params.externalRecordPermission)
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.selectRecord(parseInt(to.params.id), to.params.externalRecordPermission)
    } else {
      next(from)
    }
  },
}
</script>

<style scoped lang="scss">
  .loading-widget {
    min-height: 60vh;
  }

  .simple-label {
    font-weight: bold;
    font-size: 17px;
  }

  .custom-icon {
    cursor: pointer;
    color: #29c4a9;
    font-size: 1.2rem;
  }

  .widget {
    height: calc(100% - 1.875rem) !important;
  }
</style>
<style lang="scss" scoped>
  .dropdown-item-wrapper {
    width: 100%;

    &:hover {
      background-color: #d6d6d6;
      cursor: pointer;
    }

    &.dropdown-item-wrapper--disabled {
      color: #dddada;

      &:hover {
        background-color: whitesmoke;
        cursor: not-allowed;
      }

      & i {
        color: #dddada;
      }
    }
  }
</style>
